@if (showMicroPhonePopUp) {
  <kx-camera-audio-permssion [device]="device" [resource]="resourceName"
  (closedevicePopup)="closedevicePopup($event)"></kx-camera-audio-permssion>
}

@if (closingTime<=5 && !searchElement) {
  <div class="text-center m-2 font-weight-bold">{{"autoCl"|translate|async}}
    <span class="colorChnage"> {{closingTime}} </span></div>
  }


  <textarea [(ngModel)]="speechText" [ngClass]="!changeColor ? 'microphoneColor' : ''" class="form-control" rows="6"
    cols="1000" style="width:100%" #myTextarea (input)="mannualWritting()" [placeholder]=speakort|translate|async>
  </textarea>

  <div class="voice-mic-container">
    @if (!play) {
      <div class="voice-mic mic-off" (click)="playPause()">
        <i class="fa fa-microphone-slash" aria-hidden="true"></i>
      </div>
    }
    @if (!play) {
      <div class="voice-mic-text">
        {{'micOff'|translate|async}}
      </div>
    }
    @if (play) {
      <div class="voice-mic" (click)="playPause()">
        <i class="fa fa-microphone" aria-hidden="true"></i>
      </div>
    }
    @if (play) {
      <div class="voice-mic-text">
        {{'micOn'|translate|async}}
      </div>
    }
  </div>

  <div class="voice-accuracy">{{"param_accuracy"| translate | async}}: {{accuracy}}%</div>

  <div class="voice-progress">
    <div class="voice-progress-bar" [ngStyle]="{'width': accuracy + '%'}"></div>
  </div>

  <div class="voice-disclaimer">
    <span>{{'disclam'| translate|async}}</span>
    <span class="fa fa-info-circle" [popover]="popTemplate" container="body" triggers="mouseenter:mouseleave"
    placement="bottom" containerClass="info-popover"></span>

  </div>

  <ng-template #popTemplate>
    <table border="1">
      <tr>
        <th>{{'spokenT'|translate|async}}</th>
        <th>{{'symb'|translate|async}}</th>
      </tr>
      @for (v of  checkgrammer() | keyvalue; track v) {
        <tr>
          <td>{{v.key}}</td>
          <td class="text-center">{{replceKeyWords(v.key)?replceKeyWords(v.key):v.value}}</td>
        </tr>
      }
    </table>
  </ng-template>

<!-- </div>
</div>

</body>
</html> -->